import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { checkQuantity } from "../../actions/checkQuantity";
import { generateItems } from "../../actions/generateCommands/generateNotConfirmedUsersCommands";
import { reloadNotConfirmedUser, toggleNotConfirmedUserPanel } from "../../../../config/redux/notConfirmedUsers/notConfirmedUsersActions";
import { confirmNotConfrmedUser } from "../../../../connectors/notConfirmedUsers/connectors";
import { setErrorAlert, setListMessage } from "../../../../config/redux/alerts/alertsActions";
import { useTranslation } from 'react-i18next';

enum Roles {
  ADMIN = 1,
  DRIVER = 3,
  SERVICE_TECHNICAN = 5
}

export const useNotConfirmedUsersCommandBar = () => {

  const dispatch = useDispatch();
  const { t } = useTranslation('admin');
  const { selectedNotConfirmedUsers } = useSelector(
    (state: RootStateOrAny) => state.notConfirmedUsers
  );

  const openPanelToConfirm = () => {
    dispatch(toggleNotConfirmedUserPanel({ open: true }))
  }

  const confirmUser = async (role: Roles) => {
    try {
      var user = selectedNotConfirmedUsers[0];
      await confirmNotConfrmedUser(user.id, {
        userId: user.Id,
        roleId: role
      })
      dispatch(reloadNotConfirmedUser({ reload: true }))
      dispatch(setListMessage(t("nav.operationSuccess")))
    }
    catch (err) {
      dispatch(setErrorAlert(t("nav.error")))
    }
  }

  const confirmAsAdmin = async () => {
    confirmUser(Roles.ADMIN);
  }

  const confirmAsDriver = async () => {
    confirmUser(Roles.DRIVER);
  }

  const confirmAsServiceTechnican = async () => {
    confirmUser(Roles.SERVICE_TECHNICAN);
  }

  const actions = {
    openPanelToConfirm,
    confirmAsAdmin,
    confirmAsDriver,
    confirmAsServiceTechnican
  };

  const quantity = checkQuantity(selectedNotConfirmedUsers.length);

  const items = generateItems(quantity, actions, t);

  return {
    items,
  };
}